import React, { useEffect, useState } from "react";
import AdminSidebar from "./AdminSidebar";
import AdminHeader from "./AdminHeader";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

const base_url = process.env.REACT_APP_API_URL;

const DelayPage = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(
    !(window.innerWidth < 768)
  );
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const location = useLocation();
  const [data, setData] = useState(location?.state || null);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    min_bet: 0,
    max_bet: 0,
    bet_delay: 0,
    min_book_bet: 0,
    max_book_bet: 0,
    bet_book_delay: 0,
    min_mini_bet: 0,
    max_mini_bet: 0,
    bet_mini_delay: 0,
    min_fancy_bet: 0,
    max_fancy_bet: 0,
    bet_fancy_delay: 0,
    eventid: "",
    marketid: "",
    eventname: "",
  });

  //   console.log('state data',data);
  // Toggle sidebar visibility
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const auth = localStorage.getItem("admin");
      // console.log(formData);
      const response = await axios.post(
        base_url + "/api/webapi/eventDelay",
        formData,
        {
          headers: {
            "content-type": "application/json",
            Authorization: `${auth}`,
          },
        }
      );

      if (response?.data.success) {
        toast.success(data.eventid + response?.data.message);
        // navigate("/eventDelay");
      } else {
        toast.error(data.eventid + response?.data.message);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const fetchData = async () => {
    try {
      // console.log("request sent");
      const auth = localStorage.getItem("admin");

      const response = await axios.get(
        `${base_url}/api/webapi/getDelay/${data.eventid}`,
        {
          headers: {
            "content-type": "application/json",
            Authorization: `${auth}`,
          },
        }
      );

      // console.log("response:", response);

      if (response?.data.success) {
        const delaysString = response?.data?.result?.delays;
        const parsedDelays = JSON.parse(delaysString);

        // Merge existing defaults with fetched values
        setFormData((prev) => ({
          ...prev,
          min_bet: parsedDelays.min_bet || 0,
          max_bet: parsedDelays.max_bet || 0,
          bet_delay: parsedDelays.bet_delay || 0,

          min_book_bet: parsedDelays.min_book_bet || 0,
          max_book_bet: parsedDelays.max_book_bet || 0,
          bet_book_delay: parsedDelays.bet_book_delay || 0,

          min_mini_bet: parsedDelays.min_mini_bet || 0,
          max_mini_bet: parsedDelays.max_mini_bet || 0,
          bet_mini_delay: parsedDelays.bet_mini_delay || 0,

          min_fancy_bet: parsedDelays.min_fancy_bet || 0,
          max_fancy_bet: parsedDelays.max_fancy_bet || 0,
          bet_fancy_delay: parsedDelays.bet_fancy_delay || 0,

          eventid: parsedDelays.eventid || data.eventid,
          marketid: parsedDelays.marketid || data.marketid,
          eventname: parsedDelays.eventname || data.eventname,
        }));
      } 
    } catch (err) {
      console.error("Fetch Delay Error:", err);
      // toast.error("Something went wrong while fetching delay data.");
    }
  };

  useEffect(() => {
    if (!location.state) {
      const saved = localStorage.getItem("eventDelayData");
      if (saved) {
        setData(JSON.parse(saved));
      }
    } else {
      localStorage.setItem("eventDelayData", JSON.stringify(location.state));
      setData(location.state);
    }
  }, [location.state]);

  useEffect(() => {
    if (data?.eventid) {
      fetchData();
    }
  }, [data]);

  useEffect(() => {
    if (data?.eventid) {
      setFormData((prev) => ({
        ...prev,
        eventid: data.eventid,
        marketid: data.marketid,
        eventname: data.name,
      }));
    }
  }, [data]);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);

      if (!mobile) {
        setIsSidebarOpen(true);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // formData.eventid= data.eventid;
  // formData.marketid= data.marketid;
  // formData.eventname= data.name;

  return (
    <>
      <div className="wrapper">
        {/* <AdminSidebar
          isSidebarOpen={isSidebarOpen}
          toggleSidebar={toggleSidebar}
          isMobile={isMobile}
        />

        <AdminHeader
          toggleSidebar={toggleSidebar}
          isSidebarOpen={isSidebarOpen}
          isMobile={isMobile}
        /> */}

        <div
          className={`content-wrapper p-3 ${
            !isMobile && isSidebarOpen ? "" : "open-content-wrapper"
          }`}
          style={{
            marginLeft: !isMobile && isSidebarOpen ? "" : "0",
            transition: "margin-left 0.3s ease",
          }}
        >
          <div className="ms-2">
            <h4>{data?.name}</h4>
          </div>

          {/* <form onSubmit={(e)=>handleSubmit(e)}>
            <div className="d-flex flex-column gap-5">
                <div className="rounded-top-5 border">
                    <p className="rounded-top-5 p-3 bg-info text-center fs-5">Match Odds</p>
                    <div className="d-flex flex-wrap p-3">
                        <div className="d-flex flex-column s4 m3 col">
                            <input placeholder="Min Bet" name="min_bet" type="text" value={formData.min_bet} onChange={(e)=>handleChange(e)} />
                            <label className="text-black">Min Bet</label>
                        </div>
                        <div className=" d-flex flex-column input-field col s4 m3">
                            <input placeholder="Max Bet" name="max_bet" type="text" value={formData.max_bet} onChange={(e)=>handleChange(e)} />
                            <label className="text-black">Max Bet</label>
                        </div>

                        <div className="d-flex flex-column input-field col s4 m3">
                            <input placeholder="Bet Delay" name="bet_delay" type="text" value={formData.bet_delay} onChange={(e)=>handleChange(e)} />
                            <label className="text-black">Bet Delay</label>
                        </div>
                    </div>
                </div>

                <div className="rounded-top-5 border">
                    <p className="rounded-top-5 p-3 bg-info text-center fs-5">BookMaker</p>
                    <div className="d-flex flex-wrap p-3">
                        <div className="d-flex flex-column s4 m3 col">
                            <input placeholder="Min Bet" name="min_book_bet" type="text" value={formData.min_book_bet} onChange={(e)=>handleChange(e)} />
                            <label className="text-black">Min Bet</label>
                        </div>
                        <div className=" d-flex flex-column input-field col s4 m3">
                            <input placeholder="Max Bet" name="max_book_bet" type="text" value={formData.max_book_bet} onChange={(e)=>handleChange(e)} />
                            <label className="text-black">Max Bet</label>
                        </div>

                        <div className="d-flex flex-column input-field col s4 m3">
                            <input placeholder="Bet Delay" name="bet_book_delay" type="text" value={formData.bet_book_delay} onChange={(e)=>handleChange(e)} />
                            <label className="text-black">Bet Delay</label>
                        </div>
                    </div>
                </div>

                <div className="rounded-top-5 border">
                    <p className="rounded-top-5 p-3 bg-info text-center fs-5">Mini Bookmaker</p>
                    <div className="d-flex flex-wrap p-3">
                        <div className="d-flex flex-column s4 m3 col">
                            <input placeholder="Min Bet" name="min_mini_bet" type="text" value={formData.min_mini_bet} onChange={(e)=>handleChange(e)} />
                            <label className="text-black">Min Bet</label>
                        </div>
                        <div className=" d-flex flex-column input-field col s4 m3">
                            <input placeholder="Max Bet" name="max_mini_bet" type="text" value={formData.max_mini_bet} onChange={(e)=>handleChange(e)} />
                            <label className="text-black">Max Bet</label>
                        </div>

                        <div className="d-flex flex-column input-field col s4 m3">
                            <input placeholder="Bet Delay" name="bet_mini_delay" type="text" value={formData.bet_mini_delay} onChange={(e)=>handleChange(e)} />
                            <label className="text-black">Bet Delay</label>
                        </div>
                    </div>
                </div>

                <div className="rounded-top-5 border">
                    <p className="rounded-top-5 p-3 bg-info text-center fs-5">Fancy</p>
                    <div className="d-flex flex-wrap p-3">
                        <div className="d-flex flex-column s4 m3 col">
                            <input placeholder="Min Bet" name="min_fancy_bet" type="text" value={formData.min_fancy_bet} onChange={(e)=>handleChange(e)} />
                            <label className="text-black">Min Bet</label>
                        </div>
                        <div className=" d-flex flex-column input-field col s4 m3">
                            <input placeholder="Max Bet" name="max_fancy_bet" type="text" value={formData.max_fancy_bet} onChange={(e)=>handleChange(e)} />
                            <label className="text-black">Max Bet</label>
                        </div>

                        <div className="d-flex flex-column input-field col s4 m3">
                            <input placeholder="Bet Delay" name="bet_fancy_delay" type="text" value={formData.bet_fancy_delay} onChange={(e)=>handleChange(e)} />
                            <label className="text-black">Bet Delay</label>
                        </div>
                    </div>
                </div>
            </div>

                  <button type="submit" className="btn btn-success white-text mt-4" style={{ fontWeight: 800 }}>
                    Update
                </button>
          </form> */}

          <form onSubmit={handleSubmit}>
            <div className="container">
              {[
                {
                  title: "Match Odds",
                  fields: ["min_bet", "max_bet", "bet_delay"],
                },
                {
                  title: "BookMaker",
                  fields: ["min_book_bet", "max_book_bet", "bet_book_delay"],
                },
                {
                  title: "Mini Bookmaker",
                  fields: ["min_mini_bet", "max_mini_bet", "bet_mini_delay"],
                },
                {
                  title: "Fancy",
                  fields: ["min_fancy_bet", "max_fancy_bet", "bet_fancy_delay"],
                },
              ].map((section, idx) => (
                <div key={idx} className="card shadow-sm rounded-top-5 mb-4">
                  <div style={{backgroundColor:"#14b09d"}} className="card-header  text-white fw-bold text-center fs-5">
                    {section.title}
                  </div>
                  <div className="card-body">
                    <div className="row">
                      {section.fields.map((fieldName, fieldIdx) => (
                        <div key={fieldIdx} className="col-md-4 mb-3">
                          <label
                            htmlFor={fieldName}
                            className="form-label text-capitalize"
                          >
                            {fieldName.replaceAll("_", " ")}
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            id={fieldName}
                            name={fieldName}
                            placeholder={fieldName.replaceAll("_", " ")}
                            value={formData[fieldName]}
                            onChange={handleChange}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              ))}

              <div className="">
                <button
                  type="submit"
                  className="btn  px-5 py-2 fs-5 fw-bold"
                  style={{backgroundColor:"#14b09d"}}
                >
                  Update
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default DelayPage;